<template>
  <div class="container" :class="{ 'is-idle': isIdle }" @mouseenter="handleActivity">
    <div class="bar" ref="bar" :class="{'is-fixed': isOutOfPort}">
      <div class="bar-item"
      :class="[index === activeIndex ? 'is-active' : '', `bar-item-${index}`]"
      v-for="(item ,index) in bars" :key="index"
      @click="barHandler(item.id, index)">
        {{ item.name }}
      </div>

      <!-- <img :src="qcode" alt=""> -->

      <div
        class="qrcode-item"
        :class="{ 'is-active': qrcodeHoverId === item.id }"
        v-for="item in qrcodeList"
        :key="item.id"
        @mouseenter="mouseoverHandler(item.id)"
        @mouseleave="mouseoutHandler(item.id)"
      >
        <img
          class="img"
          :src="qrcodeHoverId === item.id ? item.hoverImg : item.img"
        >
        <p v-html="item.name"></p>

  <div
    class="qrcode"
    :aria-hidden="qrcodeHoverId !== item.id"
  >
    <img :src="item.qrcode" alt="二维码">
  </div>
      </div>

    </div>
  </div>
</template>

<script>
import VueBus from '@/utils/vueBus'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      activeIndex: 0,
      isOutOfPort: false,
      isIdle: false,
      idleTimer: null,
      itemScrollTopInfo: [],
      qrcodeHoverId: null
      // isOpen: false
    }
  },
  props: [
    'bars',
    'qrcodeList'
  ],
  computed: {
    ...mapState(['isEnLang']),

    // qcode () {
    //   return this.isEnLang ? require('../../assets/img/en/qrcode.png') : require('../../assets/img/qrcode.png')
    // }
  },
  created () {
  },
  mounted () {
    // 父元素的高度
    const barEle = document.querySelector('.bar')
    const barHeight = barEle.offsetHeight
    // 每个 item 的高度
    document.querySelectorAll('.bar-item').forEach(ele => {
      this.itemScrollTopInfo.push(ele.offsetTop + ele.offsetHeight / 2 - barHeight / 2)
    })

    VueBus.$on('setTargetIndex', this.scrollToTargetBranchHandler)

    if (this.$refs.bar && this.$refs.bar.getBoundingClientRect().left < 0) this.isOutOfPort = true

    window.addEventListener('scroll', this.handleActivity, { passive: true })
    window.addEventListener('mousemove', this.handleActivity, { passive: true })
    this.scheduleIdle()
  },
  methods: {
    /**
     * 滚动到对应的 分会
     * @param {index} Number 对应 bar 的 索引值
     */
    barHandler (id, index) {
      this.activeIndex = index

      VueBus.$emit('scrollToTargetBranch', id)

      document.querySelector('.bar').scrollTop = this.itemScrollTopInfo[index]
      // this.$scrollTo(`.bar-item-${index}`, 100, { container: '.bar', offset: -document.querySelector('.bar').offsetHeight / 2 + document.querySelector('.bar-item').offsetHeight / 2 })
    },
    // mouseOverHandler ($event) {
    //   console.log($event)
    // },
    scrollToTargetBranchHandler (index) {
      this.activeIndex = index

      if (document.querySelector('.bar')) document.querySelector('.bar').scrollTop = this.itemScrollTopInfo[index]
      // this.$scrollTo(`.bar-item-${index}`, 100, { container: '.bar', offset: -document.querySelector('.bar').offsetHeight / 2 + document.querySelector('.bar-item').offsetHeight / 2 })
    },

    mouseoverHandler (id) {
      this.qrcodeHoverId = id
    },

    mouseoutHandler (id) {
      if (this.qrcodeHoverId === id) this.qrcodeHoverId = null
    },

    handleActivity () {
      this.isIdle = false
      this.scheduleIdle()
    },

    scheduleIdle () {
      if (this.idleTimer) clearTimeout(this.idleTimer)
      this.idleTimer = setTimeout(() => {
        this.isIdle = true
      }, 900)
    }
  },
  beforeDestroy () {
    VueBus.$off('setTargetIndex', this.scrollToTargetBranchHandler)
    window.removeEventListener('scroll', this.handleActivity)
    window.removeEventListener('mousemove', this.handleActivity)
    if (this.idleTimer) clearTimeout(this.idleTimer)
  }
}
</script>

<style lang="scss" scoped>

.container {
  position: fixed; left: 0px; top: 15vh;
  width: 110px;
  background: #FFFFFF;
  transition: all 0.3s linear;
  z-index: 100;
  box-shadow: 1px 1px 8px 0px #E9E9E9;
  border-radius: 6px;

  &.is-open {
    left: 10px;
  }

  @media screen and (min-width: 1600px) {
    left: 50%;
    transform: translateX(calc(-680px - 100%))
  }

  // Keep the section directory available on smaller desktop screens instead
  // of removing it completely. The rail becomes progressively narrower so it
  // remains useful without taking over the reading area.
  // The 1200px content rail is centered on desktop. At <=1400px the
  // fixed directory can enter that rail, so it becomes collapsible.
  @media screen and (max-width: 1400px) {
    left: 10px;
    width: 102px;
  }

  @media screen and (max-width: 1400px) {
    &.is-idle {
      transform: translateX(calc(-100% + 14px));
      opacity: .18;
      pointer-events: none;
    }
  }

  @media screen and (max-width: 1180px) {
    top: 96px;
    width: 90px;
  }

  @media screen and (max-width: 980px) {
    left: 6px;
    width: 80px;
  }

  // At the tablet/narrow-laptop breakpoint the page switches to a compact
  // navigation and single-column content. Hiding the floating rail prevents
  // it from covering news cards and other primary content.
  @media screen and (max-width: 900px) {
    display: none;
  }
}
.bar {
  padding: 10px 10px 0;
  // max-height: 50vh;
  // overflow-y: scroll;
  z-index: 999;
  cursor: pointer;
  transition: all 0.3s linear;
  scroll-behavior: smooth;
  color: #818991;
  text-align: center;

  // 去掉滚动条 start
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  // 去掉滚动条 end

  .bar-item {
    height: 32px;
    font-size: 12px;
    font-weight: 400;
    color: #818991;
    line-height: 32px;
    text-align: center;
    // padding: 2px 0;
    // margin: 6px 0;
    @extend %transition;

    @include enlayoutInner {
      font-size: 14px;
    }

    &:hover {
      color: #000000;
    }
  }

  .bar-item-8 {
    margin-bottom: 20px;
  }

  .is-active {
    color: #000000;
    font-weight: 600;
  }

  .qrcode-item {
    position: relative;
    width: 56px;
    margin: 0 auto;
    padding-bottom: 20px;
    // border-top: 1px solid rgba(#828A92, 0.4);
    text-align: center;
    .img {
      width: 22px;
      margin: 0 auto;
    }
    p {
      margin: 6px 0 0;
      font-size: 12px;
      line-height: 18px;
    }

    .qrcode {
      position: absolute;
      z-index: 20;
      left: calc(100% + 16px);
      top: 50%;
      transform: translateY(-50%);
      width: 132px;
      max-width: calc(100vw - 24px);
      aspect-ratio: 1 / 1;
      padding: 8px;
      box-sizing: border-box;
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
      display: none !important;
      align-items: center;
      justify-content: center;

      img {
        position: static;
        display: block;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }

    }

    &.is-active .qrcode {
      display: flex !important;
    }
  }

}

@media screen and (max-width: 1180px) {
  .bar {
    padding: 8px 7px 0;

    .bar-item {
      height: 28px;
      font-size: 11px;
      line-height: 28px;
    }

    .bar-item-8 { margin-bottom: 12px; }

    .qrcode-item {
      width: 48px;
      padding-bottom: 14px;

      .img { width: 20px; }
      p { margin-top: 4px; font-size: 11px; line-height: 16px; }

      .qrcode {
        left: calc(100% + 10px);
        width: 112px;
        max-width: calc(100vw - 18px);
        padding: 6px;
      }
    }
  }
}

@media screen and (max-width: 980px) {
  .bar {
    padding-right: 5px;
    padding-left: 5px;

    .bar-item {
      font-size: 10px;
    }

    .qrcode-item p {
      font-size: 10px;
    }

    .qrcode {
      left: calc(100% + 8px);
      width: 88px;
      max-width: calc(100vw - 16px);
      padding: 5px;
      border-radius: 8px;
    }
  }

  @media screen and (max-width: 640px) {
    .qrcode {
      left: calc(100% + 6px);
      width: 72px;
      max-width: calc(100vw - 12px);
      padding: 4px;
      border-radius: 8px;
    }
  }
}

</style>
